// ── M12: Config ──────────────────────────────────────────────
// App-wide constants and configuration values

export const APP_NAME = 'KinkUp'
export const APP_VERSION = '2.0.0'

/** Clerk publishable key from env */
export function getClerkPublishableKey_M12_1(): string {
  const key = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
  if (!key) throw new Error('VITE_CLERK_PUBLISHABLE_KEY is not set')
  return key as string
}

/** Supabase URL from env */
export function getSupabaseUrl_M12_2(): string {
  return (import.meta.env.VITE_SUPABASE_URL as string) || 'https://placeholder.supabase.co'
}

/** Supabase anon key from env */
export function getSupabaseAnonKey_M12_3(): string {
  return (import.meta.env.VITE_SUPABASE_ANON_KEY as string) || 'placeholder-anon-key'
}

/** Check if running in demo/placeholder mode */
export function isDemoMode_M12_4(): boolean {
  return getSupabaseUrl_M12_2().includes('placeholder')
}

// ── Task Constants ──

export const TASK_STATUSES = ['pending', 'completed', 'verified', 'rejected'] as const
export const TASK_FREQUENCIES = ['once', 'daily', 'weekly', 'monthly'] as const
export const SPICE_LEVELS = [1, 2, 3, 4, 5] as const
export const USER_ROLES = ['dom', 'sub', 'switch'] as const
export const RELATIONSHIP_STATUSES = ['pending', 'active', 'ended'] as const

// ── Point Presets ──

export const POINT_PRESETS = [5, 10, 15, 25, 50, 100] as const

// ── Demo Accounts ──

export const DEMO_ACCOUNTS = {
  sir: { email: 'sir@demo.com', role: 'dom' as const, displayName: 'Sir' },
  master: { email: 'master@demo.com', role: 'dom' as const, displayName: 'Master' },
  mistress: { email: 'mistress@demo.com', role: 'dom' as const, displayName: 'Mistress' },
  kitten: { email: 'kitten@demo.com', role: 'sub' as const, displayName: 'Kitten' },
  princess: { email: 'princess@demo.com', role: 'sub' as const, displayName: 'Princess' },
  emma: { email: 'emma@demo.com', role: 'sub' as const, displayName: 'Emma' },
} as const

export const DEMO_PASSWORD = '1234'
